import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface IAuthenticationState {
    isLoggedIn: boolean;
    username: string | null;
    email: string | null;
    profileId: string | null;
}

interface ILoginAction {
    username: string;
    email: string;
    profileId: string;
}

export const authenticationStore = createSlice({
    name: 'authentication',
    initialState: {
        isLoggedIn: false,
        username: null,
        email: null,
        profileId: null,
    } as IAuthenticationState,
    reducers: {
        login(state, { payload }: PayloadAction<ILoginAction>) {
            state.email = payload.email;
            state.username = payload.username;
            state.profileId = payload.profileId;
            state.isLoggedIn = true;
        },
        logout(state) {
            state.isLoggedIn = false;
        },
    },
});
